import Vue from 'vue'
import VueTk from '@moke/vue-tk'
import store from '../store/index'
export default async () => {
  // 获取广告倒计时图片
  let res = await VueTk.tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/appImage').catch(s => {
    return { data: null }
  })
  if (res.data) { store.commit('setAdMapImage', res.data) }
  // 用户自动登录
  if (!store.state.sessionToken) {
    return
  }
  VueTk.tkParse.setSessionToken(store.state.sessionToken)
  Vue.prototype.$cloudAjax.config.headers = {
    'X-Parse-Session-Token': store.state.sessionToken
  }
  let user = await VueTk.tkParse.getData('/users/me').catch(() => {
    store.commit('setSessionToken', null)
    store.commit('setUser', null)
    VueTk.tkParse.setSessionToken('')
  })
  if (!user) return
  if (user.isDeleted) { // 已被删除的用户
    let newUser = await VueTk.tkParse.getList('/classes/_User', {
      params: {
        limit: 1,
        where: {
          phone: user.phone,
          isDeleted: false
        }
      }
    })
    if (!newUser.length) {
      store.commit('setSessionToken', null)
      store.commit('setUser', null)
      VueTk.tkParse.setSessionToken('')
      return
    }
    newUser[0].sessionToken = user.sessionToken
    user = newUser[0]
  }
  store.commit('setUser', user)
  // 获取购物车计数
  let shoppingCart = await VueTk.tkParse.getList('/classes/shoppingCart', {
    params: {
      limit: 1,
      where: {
        user: user.objectId,
        isDeleted: false
      }
    }
  })
  let sum = 0
  if ((shoppingCart && shoppingCart[0] && !shoppingCart[0].data) || !shoppingCart.length) {
    sum = 0
    store.commit('setShoppingSum', 0)
    return
  }
  shoppingCart[0].data.forEach(s => {
    if (!s.commodityData) { s.commodityData = [] }
    sum += s.commodityData.length
  })
  store.commit('setShoppingSum', sum)
}
